/* eslint-disable @typescript-eslint/no-unused-vars */
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import { AppBundle } from 'api/optimalprint-sdk.d';
import setPricesToFetchOperation from 'store/price/operation/setPricesToFetchOperation';
import collectPricesFromProduct from 'utils/price/collectPricesFromProduct';
// import posterWithFrame from 'mockups/posterWithFrame.json';
import getCommonProductRequestParams from '../selector/getCommonProductRequestParams';
import { setDesignProductAction, setProductIdAction } from '../slice';

const fetchProductOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const { encPublicDesignId, categoryId, locale } = getCommonProductRequestParams(store);

    const productData = (await apiRequest(
      endpoints.abstractProductPageV2Get,
      {
        categoryId,
        encPublicDesignId,
        isMobile: false,
        locale,
      },
      HttpMethods.GET,
      'data',
    )) as AppBundle.Api.Response.Design.V2.DesignAbstractProductPageGetV2Response;

    const encDesignId = productData.designAbstractProduct.designProductItems
      ? productData.designAbstractProduct.designProductItems[0].encDesignId
      : undefined;
    const prices = collectPricesFromProduct(
      productData.designAbstractProduct.designProductItems?.map((product) => product.product) || [],
      categoryId || 1,
      encDesignId,
    );
    dispatch(setPricesToFetchOperation(prices));

    dispatch(setDesignProductAction(productData));
    dispatch(setProductIdAction(productData.currentProduct.product.productId));
  };

export default fetchProductOperation;
